import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import AlertProvider from './components/feedback/AlertProvider';
import { ConfirmProvider } from './components/feedback/ConfirmProvider';
import './index.css';
import './App.css';
import './styles/variables.css';
import './styles/dashboard.css';
import './styles/components/alerts.css';
import './styles/confirm.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AlertProvider>
            <ConfirmProvider>
              <App />
            </ConfirmProvider>
          </AlertProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>,
);